import { HistoryRounded } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";

function NoSessions() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%">
      <IconButton
        sx={{
          height: 150,
          width: 150,
          background: "#F4F5FB",
          ":hover": { background: "#F4F5FB" },
          cursor: "pointer",
        }}>
        <HistoryRounded sx={{ fontSize: 72, color: "#8A85FF" }} />
      </IconButton>
      <Box mb={3} />
      <Typography variant="h6">No history yet!</Typography>
      <Box mb={1} />
      <Typography color="text.secondary">
        Your session history appears here
      </Typography>
    </Box>
  );
}

export default NoSessions;
